var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/algoliasearch/node_modules/isarray/index.js
// module id = 109
// module chunks = 0